/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiTransactionSummaryByAccount } from './InternalApiTransactionSummaryByAccount';
import {
    InternalApiTransactionSummaryByAccountFromJSON,
    InternalApiTransactionSummaryByAccountFromJSONTyped,
    InternalApiTransactionSummaryByAccountToJSON,
    InternalApiTransactionSummaryByAccountToJSONTyped,
} from './InternalApiTransactionSummaryByAccount';
import type { InternalApiTransactionSummaryByMonth } from './InternalApiTransactionSummaryByMonth';
import {
    InternalApiTransactionSummaryByMonthFromJSON,
    InternalApiTransactionSummaryByMonthFromJSONTyped,
    InternalApiTransactionSummaryByMonthToJSON,
    InternalApiTransactionSummaryByMonthToJSONTyped,
} from './InternalApiTransactionSummaryByMonth';

/**
 * 
 * @export
 * @interface InternalApiPersonTransactionsSummary
 */
export interface InternalApiPersonTransactionsSummary {
    /**
     * 
     * @type {number}
     * @memberof InternalApiPersonTransactionsSummary
     */
    totalReceivedAmount: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiPersonTransactionsSummary
     */
    totalSentAmount: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiPersonTransactionsSummary
     */
    averageReceivedAmount: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiPersonTransactionsSummary
     */
    averageSentAmount: number;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiPersonTransactionsSummary
     */
    firstTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiPersonTransactionsSummary
     */
    lastTime?: Date;
    /**
     * 
     * @type {number}
     * @memberof InternalApiPersonTransactionsSummary
     */
    totalSentAccounts: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiPersonTransactionsSummary
     */
    totalReceivedAccounts: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiPersonTransactionsSummary
     */
    totalSentTransactions?: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiPersonTransactionsSummary
     */
    totalReceivedTransactions?: number;
    /**
     * 
     * @type {Array<InternalApiTransactionSummaryByAccount>}
     * @memberof InternalApiPersonTransactionsSummary
     */
    bySent: Array<InternalApiTransactionSummaryByAccount>;
    /**
     * 
     * @type {Array<InternalApiTransactionSummaryByAccount>}
     * @memberof InternalApiPersonTransactionsSummary
     */
    byReceived: Array<InternalApiTransactionSummaryByAccount>;
    /**
     * 
     * @type {Array<InternalApiTransactionSummaryByMonth>}
     * @memberof InternalApiPersonTransactionsSummary
     */
    byMonth: Array<InternalApiTransactionSummaryByMonth>;
}

/**
 * Check if a given object implements the InternalApiPersonTransactionsSummary interface.
 */
export function instanceOfInternalApiPersonTransactionsSummary(value: object): value is InternalApiPersonTransactionsSummary {
    if (!('totalReceivedAmount' in value) || value['totalReceivedAmount'] === undefined) return false;
    if (!('totalSentAmount' in value) || value['totalSentAmount'] === undefined) return false;
    if (!('averageReceivedAmount' in value) || value['averageReceivedAmount'] === undefined) return false;
    if (!('averageSentAmount' in value) || value['averageSentAmount'] === undefined) return false;
    if (!('totalSentAccounts' in value) || value['totalSentAccounts'] === undefined) return false;
    if (!('totalReceivedAccounts' in value) || value['totalReceivedAccounts'] === undefined) return false;
    if (!('bySent' in value) || value['bySent'] === undefined) return false;
    if (!('byReceived' in value) || value['byReceived'] === undefined) return false;
    if (!('byMonth' in value) || value['byMonth'] === undefined) return false;
    return true;
}

export function InternalApiPersonTransactionsSummaryFromJSON(json: any): InternalApiPersonTransactionsSummary {
    return InternalApiPersonTransactionsSummaryFromJSONTyped(json, false);
}

export function InternalApiPersonTransactionsSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiPersonTransactionsSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'totalReceivedAmount': json['totalReceivedAmount'],
        'totalSentAmount': json['totalSentAmount'],
        'averageReceivedAmount': json['averageReceivedAmount'],
        'averageSentAmount': json['averageSentAmount'],
        'firstTime': json['firstTime'] == null ? undefined : (new Date(json['firstTime'])),
        'lastTime': json['lastTime'] == null ? undefined : (new Date(json['lastTime'])),
        'totalSentAccounts': json['totalSentAccounts'],
        'totalReceivedAccounts': json['totalReceivedAccounts'],
        'totalSentTransactions': json['totalSentTransactions'] == null ? undefined : json['totalSentTransactions'],
        'totalReceivedTransactions': json['totalReceivedTransactions'] == null ? undefined : json['totalReceivedTransactions'],
        'bySent': ((json['bySent'] as Array<any>).map(InternalApiTransactionSummaryByAccountFromJSON)),
        'byReceived': ((json['byReceived'] as Array<any>).map(InternalApiTransactionSummaryByAccountFromJSON)),
        'byMonth': ((json['byMonth'] as Array<any>).map(InternalApiTransactionSummaryByMonthFromJSON)),
    };
}

export function InternalApiPersonTransactionsSummaryToJSON(json: any): InternalApiPersonTransactionsSummary {
    return InternalApiPersonTransactionsSummaryToJSONTyped(json, false);
}

export function InternalApiPersonTransactionsSummaryToJSONTyped(value?: InternalApiPersonTransactionsSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalReceivedAmount': value['totalReceivedAmount'],
        'totalSentAmount': value['totalSentAmount'],
        'averageReceivedAmount': value['averageReceivedAmount'],
        'averageSentAmount': value['averageSentAmount'],
        'firstTime': value['firstTime'] == null ? value['firstTime'] : value['firstTime'].toISOString().substring(0,10),
        'lastTime': value['lastTime'] == null ? value['lastTime'] : value['lastTime'].toISOString().substring(0,10),
        'totalSentAccounts': value['totalSentAccounts'],
        'totalReceivedAccounts': value['totalReceivedAccounts'],
        'totalSentTransactions': value['totalSentTransactions'],
        'totalReceivedTransactions': value['totalReceivedTransactions'],
        'bySent': ((value['bySent'] as Array<any>).map(InternalApiTransactionSummaryByAccountToJSON)),
        'byReceived': ((value['byReceived'] as Array<any>).map(InternalApiTransactionSummaryByAccountToJSON)),
        'byMonth': ((value['byMonth'] as Array<any>).map(InternalApiTransactionSummaryByMonthToJSON)),
    };
}

